import { useQuery } from 'react-query';
import { UseQueryResult } from 'react-query';

import { APIErrorResponse } from '@bighealth/api';
import { get_user_screen_data } from '@bighealth/api/SleepNow/v1';

import { useQueryProgram } from './useQueryProgram';

export const useQuerySleepNowScreenData = (): UseQueryResult<
  get_user_screen_data.Response,
  APIErrorResponse
> => {
  const programId = useQueryProgram().data?.result.id;

  const result = useQuery<get_user_screen_data.Response, APIErrorResponse>({
    queryKey: get_user_screen_data.queryKey,
    queryFn: () =>
      get_user_screen_data({
        program_id: programId as number,
      }),
    enabled: typeof programId === 'number',
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    cacheTime: 0,
    staleTime: 0,
    retry: false,
  });
  return result;
};
